import { render, staticRenderFns } from "./addUserV2.vue?vue&type=template&id=7a0bcb8f&scoped=true"
import script from "./addUserV2.vue?vue&type=script&lang=js"
export * from "./addUserV2.vue?vue&type=script&lang=js"
import style0 from "./addUserV2.vue?vue&type=style&index=0&id=7a0bcb8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0bcb8f",
  null
  
)

export default component.exports